import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  IPrepItemBatchStandardsType,
  IPrepItemSettingsType,
  getPrepItemBatchStandards,
  getPrepItemSettings,
} from '../gql'

export interface IPrepItemBatchStandardTableData {
  key: string
  prepItem: string
  prepItemId: string
  prepBatch: string
  batchTypeId?: number
  standardUnits: string
  unitId: number
  standardUnitsPerBatch: number
  restDays: number
  minimumUnit: number
}

const usePrepItemBatchStandardsDataSource = () => {
  const { data, loading, refetch } = useQuery<IPrepItemBatchStandardsType>(
    getPrepItemBatchStandards,
  )
  const {
    data: settingsData,
    loading: settingsLoading,
    refetch: refetchSettings,
  } = useQuery<IPrepItemSettingsType>(getPrepItemSettings)

  const dataSource = useMemo(() => {
    if (!data?.getPrepItemBatchStandards || !settingsData?.getPrepItemSettings)
      return []

    return data.getPrepItemBatchStandards.nodes
      .filter((item) => item.sourceType === 'PREP')
      .map((item) => {
        // Find settings for this prep item
        const itemSettings = settingsData.getPrepItemSettings.nodes.find(
          (setting) => setting.prepItemIdCode === item.prepItemIdCode,
        )

        return {
          key: item.prepItemIdCode,
          prepItem: item.prepItemName,
          prepItemId: item.prepItemIdCode,
          prepBatch: item.prepBatchType,
          standardUnits: item.unit,
          unitId: item.unitId,
          standardUnitsPerBatch: item.standardUnitsPerBatch,
          restDays: itemSettings?.restDays || 0,
          minimumUnit: itemSettings?.minimumUnit || 0,
        }
      })
  }, [data, settingsData])

  const refetchAll = async () => {
    await Promise.all([refetch(), refetchSettings()])
  }

  return {
    loading: loading || settingsLoading,
    dataSource,
    refetch: refetchAll,
  }
}

export default usePrepItemBatchStandardsDataSource
